import React from "react";
import { Conditions } from "@/data";
import { StudyConditionsType } from "@/models";
import RadioGroupCard from "../RadioGroupCard/RadioGroupCard";

type conditionSelectionProps = {
    onChange: (value: string) => void;
    conditions?: StudyConditionsType[];
    value?: string;
};

function DiseaseGrid(props: conditionSelectionProps) {
    const { onChange, value, conditions } = props;
    const displayConditions = conditions || Conditions;
    const options = displayConditions.map((condition) => ({
        value: condition.slug,
        label: condition.title,
        imageSrc: condition.image,
        imageAlt: condition.title,
    }));

    return (
        <RadioGroupCard
            options={options}
            value={value ?? null}
            onChange={onChange}
            name="disease-selection"
        />
    );
}

DiseaseGrid.defaultProps = {
    value: undefined,
};

export default DiseaseGrid;
